import { createGlobalStyle } from "styled-components";
import globalStyles from "./theme.json";

const { colors } = globalStyles;

const GlobalStyle = createGlobalStyle`
  body {
    background-color: ${colors.primary.offWhite};
    color: ${colors.primary.green};
    font-family: "Open Sans", sans-serif;
    overflow-x: hidden;
    max-width: 1440px;
    margin: 0 auto;

    h2 {
      font-family: "Roboto", sans-serif;
      font-size: 1.5rem;
    }

    h3 {
    font-family: "Roboto", sans-serif;
    font-size: 1.3rem;
    line-height: 1.3;
  }

    p {
      font-family: "Open Sans", sans-serif;
      font-size: 1.125rem;
      line-height: 1.7;
    }

    li {
      font-family: "Open Sans", sans-serif;
      font-size: 1.125rem;
    }
  }
  
  html {}
`;

export default GlobalStyle;
